/*
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-11 15:42:24
 * @LastEditors: yd
 * @LastEditTime: 2020-11-17 18:29:52
 */
import Vue from 'vue';
import myConfirm from './myConfirm'
import i18n from '@/lang/index'

myConfirm.i18n = i18n

const ConfirmBox = Vue.extend(myConfirm)

let instance = new ConfirmBox() // 实例化

myConfirm.install = (options) => {
    if (!instance) {
        instance = new ConfirmBox()
    }
    Object.assign(instance, options)
    instance.$mount()
    document.body.appendChild(instance.$el)

    return instance.confirm()
}

export default myConfirm